import React, { Component } from 'react'
import classnames from 'classnames'
import isEmail from 'validator/lib/isEmail'
import { i18n } from '../../validator'

import Modal from '../modal'
import logout from '../../admin/actions/logout'
import Button from '../../front/components/shared/sn-button'
import Input from '../../front/components/shared/sn-input'
import {
    saveAttributesOfCurrentlyLoggedCognitoUser,
    updateCognitoUserAttributes,
} from '../../admin/actions/auth-new'

@i18n()
export default class EmailMissing extends Component {

    state = {
        email: null,
        busy: false,
        emailValid: false,
        errorMessage: null,
    }

    /**
     * on email input value change listener method
     * @param  {string} email inputted email value
     * @return {void}
     */
    onEmailChange = email => {
        const emailValid = isEmail(email)

        this.setState({
            emailValid,
            email,
        })
    }

    /**
     * Updates api email
     * @param {string} email
     * @return {Promise}
     */
    addApiEmail = email => (
        window.axios
            .patch(`${window.APP_CONFIG.REACT_APP_API_URL}api/users/me/add-email`, {
                email: email,
            })
            .then(() => {
                window.location.reload()
            })
            .catch(({ data }) => {
                if (data && data.errors) {
                    const validationErrors = Object.values(data.errors)
                        .reduce((acc, cval) => `${acc} ${cval}\n`)

                    this.setState({
                        errorMessage: validationErrors,
                    })
                }
            })
    )

    /**
     * Updates cognito user email
     * @param {string} email
     * @return {Promise}
     */
    addCognitoEmail = email => (
        updateCognitoUserAttributes({ 'email': email })
            .then(() => saveAttributesOfCurrentlyLoggedCognitoUser())
    )

    /**
     * handle modal form submit
     * @param  {Object} e submit event
     * @return {Promise}
     */
    handleSubmit = e => {
        e.preventDefault()

        const { email } = this.state
        const { t } = this.props

        this.setState({ busy: true })

        return Promise.allSettled([
            this.addApiEmail(email),
            this.addCognitoEmail(email),
        ])
            .then(() => this.setState({ busy: false }))
            .catch(() => window.swalert(t('serverErrorMessage')))
    }

    render = () => {
        const { t } = this.props

        const {
            email,
            errorMessage,
            busy,
            emailValid,
        } = this.state

        let message = null

        if (errorMessage?.includes('validation.unique')) {
            message = t('emailExists')
        }

        return (
            <Modal
                handleHideModal={() => logout()}
                description='Uživatelský email není vyplněn'
                content={() =>
                    <div className="p-4">
                        <h6 className="m-0">
                            Pro správné využívání portálu Sportnect je nutné mít vyplněnou e-mailovou adresu. Prosíme vyplňte svou emailovou adresu a používejte dále systém Sportnect.
                        </h6>
                        <form onSubmit={this.handleSubmit}>
                            <div className="modal-body">
                                <Input
                                    type="email"
                                    label="Email"
                                    placeholder="Email"
                                    value={email || ''}
                                    onChange={({ target }) => this.onEmailChange(target.value)}
                                    className="form-control form-control-sm"
                                    required
                                    maxLength="50"
                                />
                                <span className="font-weight-bold text-dark">{t(message)}</span>
                            </div>
                            <div className="modal-footer">
                                <Button
                                    submit
                                    className={classnames({
                                        'btn btn-color-brand': true,
                                        'btn-loading': busy,
                                        'btn-disabled': !emailValid || busy,
                                    })}
                                >
                                    Pokračovat
                                </Button>
                            </div>
                        </form>
                    </div>
                }
                keyboard={false}
                backdrop="static"
            />
        )
    }
}
